"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Data Service API
 * ADS API Service is responsible for managing organization\'s assets
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rswarriors@arcticwolf.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationExpressionToJSON = exports.OperationExpressionFromJSONTyped = exports.OperationExpressionFromJSON = exports.instanceOfOperationExpression = exports.OperationExpressionOperatorEnum = void 0;
var OneOfExpression_1 = require("./OneOfExpression");
/**
 * @export
 */
exports.OperationExpressionOperatorEnum = {
    And: 'and',
    Any: 'any',
    All: 'all',
    Eq: 'eq',
    Ne: 'ne',
    Gte: 'gte',
    Lte: 'lte',
    Lt: 'lt',
    Gt: 'gt',
    Like: 'like',
    Isnull: 'isnull'
};
/**
 * Check if a given object implements the OperationExpression interface.
 */
function instanceOfOperationExpression(value) {
    var isInstance = true;
    isInstance = isInstance && "operator" in value;
    isInstance = isInstance && "arguments" in value;
    return isInstance;
}
exports.instanceOfOperationExpression = instanceOfOperationExpression;
function OperationExpressionFromJSON(json) {
    return OperationExpressionFromJSONTyped(json, false);
}
exports.OperationExpressionFromJSON = OperationExpressionFromJSON;
function OperationExpressionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'operator': json['operator'],
        'arguments': (json['arguments'].map(OneOfExpression_1.OneOfExpressionFromJSON)),
    };
}
exports.OperationExpressionFromJSONTyped = OperationExpressionFromJSONTyped;
function OperationExpressionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'operator': value.operator,
        'arguments': (value.arguments.map(OneOfExpression_1.OneOfExpressionToJSON)),
    };
}
exports.OperationExpressionToJSON = OperationExpressionToJSON;
